export default "__VITE_ASSET__CUeR3R28__"